// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yrgA","rootMobile":"styles_rootMobile__1-O1F"};